<template>
  <div class="nabadoon-registration">
    <v-container>
      <v-card>
        <v-card-title class="page-head">
          <div class="ph-left">
            <div class="ph-icon"><v-icon color="#00695c">mdi-account-tie</v-icon></div>
            <div>
              <div class="ph-title">Clan Elder Registration</div>
              <div class="ph-sub">Register and manage clan elders</div>
            </div>
          </div>
          <v-spacer />
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            placeholder="Search..."
            outlined
            dense
            hide-details
            class="ph-search"
          />
          <v-btn class="ph-btn" @click="formNuevo()">
            <v-icon left small>mdi-plus</v-icon>
            New Elder
          </v-btn>
        </v-card-title>

        <v-data-table
          :search="search"
          :headers="headers"
          :items="nabadoons"
          :items-per-page="-1"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, -1], 'items-per-page-text': 'Rows per page' }"
          class="elevation-0"
        >
          <template v-slot:item.index="{ index }">
            <span class="cell-muted">{{ index + 1 }}</span>
          </template>

          <template v-slot:item.image="{ item }">
            <v-avatar size="38" class="avatar-ring">
              <v-img v-if="item.image" :src="uploadBaseUrl + item.image" />
              <v-icon v-else color="#90a4ae">mdi-account-tie</v-icon>
            </v-avatar>
          </template>

          <template v-slot:item.name="{ item }">
            <span class="cell-name">{{ item.name }}</span>
          </template>

          <template v-slot:item.tribe="{ item }">
            <v-chip v-if="item.tribe" small outlined color="teal">{{ item.tribe }}</v-chip>
            <span v-else class="cell-muted">—</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="#2e7d32" v-bind="attrs" v-on="on" @click="formEditar(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit elder</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="#c62828" v-bind="attrs" v-on="on" @click="borrar(item.id)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Delete elder</span>
            </v-tooltip>
          </template>

          <template v-slot:item.more="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="#1565c0" v-bind="attrs" v-on="on" @click="show(item.id)">
                  <v-icon small>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>View details</span>
            </v-tooltip>
          </template>

          <template v-slot:no-data>
            <div class="empty-state">
              <v-icon size="44" color="#b0bec5">mdi-account-tie-outline</v-icon>
              <div class="empty-text">No clan elders found</div>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <!-- Dialog: More Info -->
      <v-dialog v-model="diag" max-width="420px">
        <v-card v-for="more in moreinfo" :key="more.id">
          <div class="dlg-head">
            <div class="dlg-head-icon"><v-icon color="#fff">mdi-account-tie</v-icon></div>
            <div>
              <div class="dlg-title">Elder Details</div>
              <div class="dlg-sub">{{ more.name }}</div>
            </div>
            <v-spacer />
            <v-btn icon small class="dlg-close" @click="diag = false"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <div class="d-flex justify-center pt-5 pb-2">
            <v-avatar size="88" class="avatar-ring lg">
              <v-img v-if="more.image" :src="uploadBaseUrl + more.image" />
              <v-icon v-else size="40" color="#90a4ae">mdi-account-tie</v-icon>
            </v-avatar>
          </div>
          <v-card-text>
            <v-simple-table>
              <tbody>
                <tr><th>Name</th><td>{{ more.name }}</td></tr>
                <tr><th>Phone</th><td>{{ more.phone }}</td></tr>
                <tr><th>Address</th><td>{{ more.address }}</td></tr>
                <tr><th>Clan</th><td>{{ more.qabiil || more.tribe }}</td></tr>
                <tr><th>Districts</th><td>{{ districtNames(more.districts) }}</td></tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog: Create/Edit -->
      <v-dialog v-model="dialog" max-width="640px" persistent>
        <v-card>
          <div class="dlg-head">
            <div class="dlg-head-icon">
              <v-icon color="#fff">{{ oper === 'Add' ? 'mdi-account-plus' : 'mdi-account-edit' }}</v-icon>
            </div>
            <div>
              <div class="dlg-title">{{ oper === 'Add' ? 'New Clan Elder' : 'Edit Clan Elder' }}</div>
              <div class="dlg-sub">{{ oper === 'Add' ? 'Register a new elder' : 'Update elder details & districts' }}</div>
            </div>
            <v-spacer />
            <v-btn icon small class="dlg-close" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
          </div>
          <v-card-text class="pt-5">
            <v-form>
              <input type="hidden" v-model="nabadoon.id" />

              <div class="photo-row">
                <v-avatar size="64" class="avatar-ring lg">
                  <v-img v-if="nabadoon.image" :src="uploadBaseUrl + nabadoon.image" />
                  <v-icon v-else size="30" color="#90a4ae">mdi-account-tie</v-icon>
                </v-avatar>
                <v-file-input
                  accept="image/*"
                  label="Photo"
                  prepend-icon="mdi-camera"
                  outlined
                  dense
                  hide-details
                  show-size
                  class="photo-input"
                  @change="onFilechange"
                />
                <input type="hidden" v-model="nabadoon.image" />
              </div>

              <div class="form-section">Elder Details</div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field v-model="nabadoon.name" label="Name" outlined dense prepend-inner-icon="mdi-account-outline" required />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="nabadoon.phone" label="Phone" outlined dense prepend-inner-icon="mdi-phone-outline" required />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="nabadoon.address" label="Address" outlined dense prepend-inner-icon="mdi-map-marker-outline" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="nabadoon.qabiil" label="Clan" outlined dense prepend-inner-icon="mdi-account-group-outline" />
                </v-col>
              </v-row>

              <div class="form-section">District Visibility</div>
              <v-row dense>
                <v-col cols="12">
                  <v-select
                    v-model="nabadoon.districts"
                    :items="districts"
                    item-text="district_name"
                    item-value="id"
                    label="Districts"
                    multiple
                    chips
                    small-chips
                    outlined
                    dense
                    prepend-inner-icon="mdi-map-marker-multiple-outline"
                    hint="All districts where this clan is visible"
                    persistent-hint
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="dlg-actions">
            <v-spacer />
            <v-btn text @click="dialog = false">Cancel</v-btn>
            <v-btn color="#0d2d63" dark @click="guardar()">
              <v-icon left small>mdi-content-save-outline</v-icon>
              {{ oper === 'Add' ? 'Save Elder' : 'Save Changes' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" bottom right color="blue">
        {{ text }}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;
const UPLOAD_URL = process.env.VUE_APP_UPLOAD_URL;
const IMAGE_BASE = process.env.VUE_APP_IMAGE_BASE;

export default {
  data() {
    return {
      search: '',
      nabadoons: [], // This will hold the list of mothers
      dialog: false,
      diag: false,
      oper: 'Add',
      operacion: '',
      snackbar: false,
      multiLine: true,
      text: '',
      moreinfo: [],
      uploadBaseUrl: IMAGE_BASE,
      districts: [],
      nabadoon: {
        id: '',
        name: '',
        phone: '',
        image: '',
        address: '',
        qabiil: '',
        districts: [],
        usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''
      },
      headers: [
        { text: 'No', value: 'index' },
        { text: 'Image', value: 'image' },
        { text: 'Name', value: 'name' },
        { text: 'Phone', value: 'phone' },
        { text: 'Address', value: 'address' },
        { text: 'Clan', value: 'tribe' },
        { text: 'Show More', value: 'more', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },

  mounted() {
    this.mostrar();
    this.fetchDistricts();
  },

  methods: {
    fetchDistricts() {
      axios.post(API_URL, { opcion: 40 }).then((res) => {
        this.districts = Array.isArray(res.data) ? res.data : [];
      }).catch((e) => console.error('Failed to load districts', e));
    },

    districtNames(ids) {
      if (!ids) return '—';
      const list = Array.isArray(ids) ? ids : String(ids).split(',').filter(Boolean);
      const names = list.map((id) => {
        const d = this.districts.find((x) => String(x.id) === String(id));
        return d ? d.district_name : id;
      });
      return names.join(', ') || '—';
    },

    onFilechange(file) {
      if (!file) return;
      const formData = new FormData();
      formData.append('file', file);
      axios
        .post(UPLOAD_URL, formData)
        .then((res) => {
          this.nabadoon.image = res.data;
          this.snackbar = true;
          this.text = 'Image uploaded successfully!';
        })
        .catch(() => {
          this.snackbar = true;
          this.text = 'Image upload failed!';
        });
    },

    formNuevo() {
      this.dialog = true;
      this.oper = 'Add';
      this.nabadoon = {
        id: '',
        name: '',
        phone: '',
        image: '',
        address: '',
        qabiil: '',
        districts: [],
        usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''
      };
    },

    formEditar(item) {
      this.dialog = true;
      this.oper = 'Update';
      this.nabadoon = { ...item };
      // The list API returns the clan as 'tribe' — map it to the form field 'qabiil'
      this.nabadoon.qabiil = item.qabiil || item.tribe || '';
      // Keep the owner id — the row may not carry usr_id, so fall back to the session user
      this.nabadoon.usr_id = item.usr_id || item.user_id
        || (JSON.parse(localStorage.getItem('user') || '{}')).id || '';
      // Normalize districts to an array of ids (backend may return CSV or array)
      const d = item.districts;
      this.nabadoon.districts = Array.isArray(d)
        ? d
        : (d ? String(d).split(',').filter(Boolean).map((x) => (isNaN(x) ? x : Number(x))) : []);
    },

    guardar() {
      this.oper === 'Add' ? this.crear() : this.editar();
      this.dialog = false;
    },

    crear() {
      const payload = {
        opcion: 12, // A new option for mother CRUD
        op: 1,
        idga: this.nabadoon.id,
        magac: this.nabadoon.name,
        telefoon: this.nabadoon.phone,
        sawir: this.nabadoon.image || 'logo.png',
        ciwaanka: this.nabadoon.address,
        qabiil: this.nabadoon.qabiil,
        tribe: this.nabadoon.qabiil,
        districts: (this.nabadoon.districts || []).join(','),
        user_id: this.nabadoon.usr_id,

      };
      axios.post(API_URL, payload).then((res) => {
        console.log(res)
        this.mostrar();
        this.text = 'Inserted successfully';
        this.snackbar = true;
      });
    },

    editar() {
      const payload = {
        opcion: 12, // A new option for mother CRUD
        op: 11,
        idga: this.nabadoon.id,
        magac: this.nabadoon.name,
        telefoon: this.nabadoon.phone,
        sawir: this.nabadoon.image,
        ciwaanka: this.nabadoon.address,
        qabiil: this.nabadoon.qabiil || this.nabadoon.tribe || '',
        tribe: this.nabadoon.qabiil || this.nabadoon.tribe || '',
        districts: (this.nabadoon.districts || []).join(','),
        user_id: this.nabadoon.usr_id,
      };
      axios.post(API_URL, payload).then((res) => {
        this.mostrar();
        this.text = 'Updated successfully';
        this.snackbar = true;
      });
    },

    borrar(id) {
      axios.post(API_URL, { opcion: 12, op: 12, idga: id, user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' }).then(() => {
        this.mostrar();
        this.text = 'Deleted successfully';
        this.snackbar = true;
      });
    },

    show(id) {
      axios.post(API_URL, {opcion: 12, op: 23, idga: id, user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' }).then((res) => {
        this.moreinfo = res.data;
        this.diag = true;
      });
    },

    mostrar() {
      axios.post(API_URL, { opcion: 12, op: 0, user_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || '' }).then((res) => {
        this.nabadoons = res.data;
        console.log(res.data)
      });
    },
  },
};
</script>

<style scoped>
.nabadoon-registration {
  margin-top: 20px;
}
</style>
